// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AddOrganizationData,
  AddOrganizationErrors,
  AddOrganizationResponses,
  CreateOrganizationGroupData,
  CreateOrganizationGroupErrors,
  CreateOrganizationGroupResponses,
  DeleteOrganizationGroupData,
  DeleteOrganizationGroupErrors,
  DeleteOrganizationGroupResponses,
  ExternalUpdateTenantData,
  ExternalUpdateTenantErrors,
  ExternalUpdateTenantResponses,
  GetCloudOrganizationBillingInformationData,
  GetCloudOrganizationBillingInformationErrors,
  GetCloudOrganizationBillingInformationResponses,
  GetCloudOrganizationData,
  GetCloudOrganizationErrors,
  GetCloudOrganizationResponses,
  GetCloudOrganizationsData,
  GetCloudOrganizationsErrors,
  GetCloudOrganizationsResponses,
  GetDefaultOverageTiersData,
  GetDefaultOverageTiersResponses,
  GetLicenseInformationData,
  GetLicenseInformationErrors,
  GetLicenseInformationResponses,
  GetOrganizationBillingAuditData,
  GetOrganizationBillingAuditErrors,
  GetOrganizationBillingAuditResponses,
  GetOrganizationChargesData,
  GetOrganizationChargesErrors,
  GetOrganizationChargesResponses,
  GetOrganizationCurrencyData,
  GetOrganizationCurrencyErrors,
  GetOrganizationCurrencyResponses,
  GetOrganizationData,
  GetOrganizationErrors,
  GetOrganizationGroupsData,
  GetOrganizationGroupsErrors,
  GetOrganizationGroupsResponses,
  GetOrganizationMetersData,
  GetOrganizationMetersErrors,
  GetOrganizationMetersResponses,
  GetOrganizationPaymentsData,
  GetOrganizationPaymentsErrors,
  GetOrganizationPaymentsResponses,
  GetOrganizationPeriodUsageData,
  GetOrganizationPeriodUsageErrors,
  GetOrganizationPeriodUsageResponses,
  GetOrganizationResponses,
  GetOrganizationsData,
  GetOrganizationsErrors,
  GetOrganizationsResponses,
  GetOrgInformationData,
  GetOrgInformationErrors,
  GetOrgInformationResponses,
  GetPaymentsData,
  GetPaymentsErrors,
  GetPaymentsResponses,
  GetTenantBillingAuditData,
  GetTenantBillingAuditErrors,
  GetTenantBillingAuditResponses,
  GetTenantCurrencyData,
  GetTenantCurrencyErrors,
  GetTenantCurrencyResponses,
  GetTenantInformationData,
  GetTenantInformationErrors,
  GetTenantInformationResponses,
  GetTenantMetersData,
  GetTenantMetersErrors,
  GetTenantMetersResponses,
  GetTenantPeriodUsageData,
  GetTenantPeriodUsageErrors,
  GetTenantPeriodUsageResponses,
  MergeTenantsData,
  MergeTenantsErrors,
  MergeTenantsResponses,
  NewTenantData,
  NewTenantErrors,
  NewTenantResponses,
  OpenOrganizationStripeBillingPortalData,
  OpenOrganizationStripeBillingPortalErrors,
  OpenOrganizationStripeBillingPortalResponses,
  OpenStripeBillingPortalData,
  OpenStripeBillingPortalErrors,
  OpenStripeBillingPortalResponses,
  RenameOrganizationGroupData,
  RenameOrganizationGroupErrors,
  RenameOrganizationGroupResponses,
  RenameTenantAdminData,
  RenameTenantAdminErrors,
  RenameTenantAdminResponses,
  SearchCustomersData,
  SearchCustomersErrors,
  SearchCustomersResponses,
  SendPreviousPeriodDataData,
  SendPreviousPeriodDataErrors,
  SendPreviousPeriodDataResponses,
  SetOrganizationGroupData,
  SetOrganizationGroupErrors,
  SetOrganizationGroupResponses,
  SetOrganizationVisibilityData,
  SetOrganizationVisibilityErrors,
  SetOrganizationVisibilityResponses,
  UpdateOrganizationData2,
  UpdateOrganizationErrors,
  UpdateOrganizationResponses,
  UpdateTenantData2,
  UpdateTenantErrors,
  UpdateTenantResponses,
  UpgradeOrganizationSubscriptionData,
  UpgradeOrganizationSubscriptionErrors,
  UpgradeOrganizationSubscriptionResponses,
  UpgradeTenantSubscription2Data,
  UpgradeTenantSubscription2Errors,
  UpgradeTenantSubscription2Responses,
  UpgradeTenantSubscriptionData,
  UpgradeTenantSubscriptionErrors,
  UpgradeTenantSubscriptionResponses,
  WebhookSubscriptionUpdatedData,
  WebhookSubscriptionUpdatedErrors,
  WebhookSubscriptionUpdatedResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, true> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export class LicenseService {
  /**
   * Get License Information
   */
  public static getLicenseInformation(
    options: Options<GetLicenseInformationData, true>
  ) {
    return (options.client ?? client).post<
      GetLicenseInformationResponses,
      GetLicenseInformationErrors,
      true
    >({
      responseType: "json",
      url: "/license",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Send Previous Period Data
   */
  public static sendPreviousPeriodData(
    options: Options<SendPreviousPeriodDataData, true>
  ) {
    return (options.client ?? client).post<
      SendPreviousPeriodDataResponses,
      SendPreviousPeriodDataErrors,
      true
    >({
      responseType: "json",
      url: "/license/old",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * New Tenant
   */
  public static newTenant(options: Options<NewTenantData, true>) {
    return (options.client ?? client).post<
      NewTenantResponses,
      NewTenantErrors,
      true
    >({
      responseType: "json",
      url: "/license/tenant",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * External Update Tenant
   */
  public static externalUpdateTenant(
    options: Options<ExternalUpdateTenantData, true>
  ) {
    return (options.client ?? client).patch<
      ExternalUpdateTenantResponses,
      ExternalUpdateTenantErrors,
      true
    >({
      responseType: "json",
      url: "/license/tenant/{tenant_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class AdminService {
  /**
   * Get Cloud Organizations
   */
  public static getCloudOrganizations(
    options?: Options<GetCloudOrganizationsData, true>
  ) {
    return (options?.client ?? client).get<
      GetCloudOrganizationsResponses,
      GetCloudOrganizationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/cloud-organizations",
      ...options,
    });
  }

  /**
   * Get Cloud Organization
   */
  public static getCloudOrganization(
    options: Options<GetCloudOrganizationData, true>
  ) {
    return (options.client ?? client).get<
      GetCloudOrganizationResponses,
      GetCloudOrganizationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/cloud-organization/{id}",
      ...options,
    });
  }

  /**
   * Get Cloud Organization Billing Information
   */
  public static getCloudOrganizationBillingInformation(
    options: Options<GetCloudOrganizationBillingInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetCloudOrganizationBillingInformationResponses,
      GetCloudOrganizationBillingInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/cloud-organization/{id}/billing-information",
      ...options,
    });
  }

  /**
   * Get Organizations
   */
  public static getOrganizations(
    options?: Options<GetOrganizationsData, true>
  ) {
    return (options?.client ?? client).get<
      GetOrganizationsResponses,
      GetOrganizationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations",
      ...options,
    });
  }

  /**
   * Add Organization
   */
  public static addOrganization(options: Options<AddOrganizationData, true>) {
    return (options.client ?? client).post<
      AddOrganizationResponses,
      AddOrganizationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Organization Groups
   */
  public static getOrganizationGroups(
    options?: Options<GetOrganizationGroupsData, true>
  ) {
    return (options?.client ?? client).get<
      GetOrganizationGroupsResponses,
      GetOrganizationGroupsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organization-groups",
      ...options,
    });
  }

  /**
   * Create Organization Group
   */
  public static createOrganizationGroup(
    options: Options<CreateOrganizationGroupData, true>
  ) {
    return (options.client ?? client).post<
      CreateOrganizationGroupResponses,
      CreateOrganizationGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organization-groups",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Organization Group
   */
  public static deleteOrganizationGroup(
    options: Options<DeleteOrganizationGroupData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteOrganizationGroupResponses,
      DeleteOrganizationGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organization-groups/{group_id}",
      ...options,
    });
  }

  /**
   * Rename Organization Group
   */
  public static renameOrganizationGroup(
    options: Options<RenameOrganizationGroupData, true>
  ) {
    return (options.client ?? client).patch<
      RenameOrganizationGroupResponses,
      RenameOrganizationGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organization-groups/{group_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set Organization Group
   */
  public static setOrganizationGroup(
    options: Options<SetOrganizationGroupData, true>
  ) {
    return (options.client ?? client).put<
      SetOrganizationGroupResponses,
      SetOrganizationGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organization-group-membership",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set Organization Visibility
   */
  public static setOrganizationVisibility(
    options: Options<SetOrganizationVisibilityData, true>
  ) {
    return (options.client ?? client).put<
      SetOrganizationVisibilityResponses,
      SetOrganizationVisibilityErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organization-visibility",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Organization
   */
  public static getOrganization(options: Options<GetOrganizationData, true>) {
    return (options.client ?? client).get<
      GetOrganizationResponses,
      GetOrganizationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{org_id}",
      ...options,
    });
  }

  /**
   * Update Tenant
   */
  public static updateTenant(options: Options<UpdateTenantData2, true>) {
    return (options.client ?? client).patch<
      UpdateTenantResponses,
      UpdateTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenants/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Organization
   */
  public static updateOrganization(
    options: Options<UpdateOrganizationData2, true>
  ) {
    return (options.client ?? client).patch<
      UpdateOrganizationResponses,
      UpdateOrganizationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Default Overage Tiers
   */
  public static getDefaultOverageTiers(
    options?: Options<GetDefaultOverageTiersData, true>
  ) {
    return (options?.client ?? client).get<
      GetDefaultOverageTiersResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/default-overage-tiers",
      ...options,
    });
  }

  /**
   * Get Organization Charges
   */
  public static getOrganizationCharges(
    options: Options<GetOrganizationChargesData, true>
  ) {
    return (options.client ?? client).get<
      GetOrganizationChargesResponses,
      GetOrganizationChargesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{org_id}/charges",
      ...options,
    });
  }

  /**
   * Get Organization Billing Audit
   */
  public static getOrganizationBillingAudit(
    options: Options<GetOrganizationBillingAuditData, true>
  ) {
    return (options.client ?? client).get<
      GetOrganizationBillingAuditResponses,
      GetOrganizationBillingAuditErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{org_id}/billing-audit",
      ...options,
    });
  }

  /**
   * Get Tenant Billing Audit
   */
  public static getTenantBillingAudit(
    options: Options<GetTenantBillingAuditData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantBillingAuditResponses,
      GetTenantBillingAuditErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenants/{id}/billing-audit",
      ...options,
    });
  }

  /**
   * Get Organization Meters
   */
  public static getOrganizationMeters(
    options: Options<GetOrganizationMetersData, true>
  ) {
    return (options.client ?? client).get<
      GetOrganizationMetersResponses,
      GetOrganizationMetersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{id}/meters",
      ...options,
    });
  }

  /**
   * Get Tenant Meters
   */
  public static getTenantMeters(options: Options<GetTenantMetersData, true>) {
    return (options.client ?? client).get<
      GetTenantMetersResponses,
      GetTenantMetersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenants/{id}/meters",
      ...options,
    });
  }

  /**
   * Get Organization Period Usage
   */
  public static getOrganizationPeriodUsage(
    options: Options<GetOrganizationPeriodUsageData, true>
  ) {
    return (options.client ?? client).get<
      GetOrganizationPeriodUsageResponses,
      GetOrganizationPeriodUsageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{id}/period-usage",
      ...options,
    });
  }

  /**
   * Get Tenant Period Usage
   */
  public static getTenantPeriodUsage(
    options: Options<GetTenantPeriodUsageData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantPeriodUsageResponses,
      GetTenantPeriodUsageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenants/{id}/period-usage",
      ...options,
    });
  }

  /**
   * Webhook Subscription Updated
   */
  public static webhookSubscriptionUpdated(
    options: Options<WebhookSubscriptionUpdatedData, true>
  ) {
    return (options.client ?? client).post<
      WebhookSubscriptionUpdatedResponses,
      WebhookSubscriptionUpdatedErrors,
      true
    >({
      responseType: "json",
      url: "/payment/stripe/webhook-subscription-updated",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Upgrade Tenant Subscription
   */
  public static upgradeTenantSubscription(
    options: Options<UpgradeTenantSubscriptionData, true>
  ) {
    return (options.client ?? client).post<
      UpgradeTenantSubscriptionResponses,
      UpgradeTenantSubscriptionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenants/{tenant_id}/upgrade",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Upgrade Organization Subscription
   */
  public static upgradeOrganizationSubscription(
    options: Options<UpgradeOrganizationSubscriptionData, true>
  ) {
    return (options.client ?? client).post<
      UpgradeOrganizationSubscriptionResponses,
      UpgradeOrganizationSubscriptionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/organizations/{org_id}/upgrade",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Rename Tenant Admin
   */
  public static renameTenantAdmin(
    options: Options<RenameTenantAdminData, true>
  ) {
    return (options.client ?? client).patch<
      RenameTenantAdminResponses,
      RenameTenantAdminErrors,
      true
    >({
      responseType: "json",
      security: [{ name: "X-API-Key", type: "apiKey" }],
      url: "/tenants/{id}/rename",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Merge Tenants
   */
  public static mergeTenants(options: Options<MergeTenantsData, true>) {
    return (options.client ?? client).post<
      MergeTenantsResponses,
      MergeTenantsErrors,
      true
    >({
      responseType: "json",
      security: [{ name: "X-API-Key", type: "apiKey" }],
      url: "/tenants/merge",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Search Customers
   */
  public static searchCustomers(options: Options<SearchCustomersData, true>) {
    return (options.client ?? client).post<
      SearchCustomersResponses,
      SearchCustomersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/customers/search",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class PaymentService {
  /**
   * Get Org Information
   */
  public static getOrgInformation(
    options?: Options<GetOrgInformationData, true>
  ) {
    return (options?.client ?? client).get<
      GetOrgInformationResponses,
      GetOrgInformationErrors,
      true
    >({
      responseType: "json",
      url: "/user/organization",
      ...options,
    });
  }

  /**
   * Get Tenant Information
   */
  public static getTenantInformation(
    options: Options<GetTenantInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantInformationResponses,
      GetTenantInformationErrors,
      true
    >({
      responseType: "json",
      url: "/tenant/{tenant_id}",
      ...options,
    });
  }

  /**
   * Get Organization Currency
   */
  public static getOrganizationCurrency(
    options?: Options<GetOrganizationCurrencyData, true>
  ) {
    return (options?.client ?? client).get<
      GetOrganizationCurrencyResponses,
      GetOrganizationCurrencyErrors,
      true
    >({
      responseType: "json",
      url: "/user/organization/currency",
      ...options,
    });
  }

  /**
   * Get Tenant Currency
   */
  public static getTenantCurrency(
    options: Options<GetTenantCurrencyData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantCurrencyResponses,
      GetTenantCurrencyErrors,
      true
    >({
      responseType: "json",
      url: "/tenant/{tenant_id}/currency",
      ...options,
    });
  }

  /**
   * Open Stripe Billing Portal
   */
  public static openStripeBillingPortal(
    options: Options<OpenStripeBillingPortalData, true>
  ) {
    return (options.client ?? client).post<
      OpenStripeBillingPortalResponses,
      OpenStripeBillingPortalErrors,
      true
    >({
      responseType: "json",
      url: "/tenant/{tenant_id}/stripe",
      ...options,
    });
  }

  /**
   * Open Organization Stripe Billing Portal
   */
  public static openOrganizationStripeBillingPortal(
    options?: Options<OpenOrganizationStripeBillingPortalData, true>
  ) {
    return (options?.client ?? client).post<
      OpenOrganizationStripeBillingPortalResponses,
      OpenOrganizationStripeBillingPortalErrors,
      true
    >({
      responseType: "json",
      url: "/user/organization/stripe",
      ...options,
    });
  }

  /**
   * Upgrade Tenant Subscription
   */
  public static upgradeTenantSubscription(
    options: Options<UpgradeTenantSubscription2Data, true>
  ) {
    return (options.client ?? client).post<
      UpgradeTenantSubscription2Responses,
      UpgradeTenantSubscription2Errors,
      true
    >({
      responseType: "json",
      url: "/tenant/{tenant_id}/upgrade",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Payments
   */
  public static getPayments(options: Options<GetPaymentsData, true>) {
    return (options.client ?? client).get<
      GetPaymentsResponses,
      GetPaymentsErrors,
      true
    >({
      responseType: "json",
      url: "/tenant/{tenant_id}/payments",
      ...options,
    });
  }

  /**
   * Get Organization Payments
   */
  public static getOrganizationPayments(
    options?: Options<GetOrganizationPaymentsData, true>
  ) {
    return (options?.client ?? client).get<
      GetOrganizationPaymentsResponses,
      GetOrganizationPaymentsErrors,
      true
    >({
      responseType: "json",
      url: "/user/organization/payments",
      ...options,
    });
  }
}
